<template>
  <div>
    Google Analytics ID
    <pre>{{ id }}</pre>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const id = ref('?');

onMounted(() => {
  if (typeof ga === 'function') {
    ga(function (tracker) {
      id.value = tracker.get('clientId');
    });
  }
});
</script>
